// extracted by mini-css-extract-plugin
module.exports = {"container":"SpinBlock_container__cBTVP","SpinBlockSpawn":"SpinBlock_SpinBlockSpawn__EH_52"};